import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { linkify } from '../../../utils/a11y.utils';

import type { Video } from '../../model/video.interface';
import { VideoType } from '../../model/video.interface';
import { usePerksConfig } from '../perks/perks-config.context';

interface Props {
  key: string;
  video: Video;
}

export const PerksVideo = ({ key, video }: Props) => {
  const { showVideoTitle, showVideoDate } = usePerksConfig();
  dayjs.extend(utc);
  dayjs.extend(timezone);

  if (!video) return null;

  const handleClick = () => {
    window.open(video.url, '_self');
  };

  const isLive = useMemo(() => {
    return video.videoType === VideoType.Live;
  }, [video.videoType]);

  const eventDate = useMemo(() => {
    const date = dayjs(video.eventDate).tz('America/New_York');

    // -300 = UTC-5 (Standard), -240 = UTC-4 (Daylight)
    const offset = date.utcOffset() === -300 ? 'EST' : 'EDT';

    return `${date.format('MMM DD • hh:mm a')} ${offset}`;
  }, [video.eventDate]);

  return (
    <div class="single-card" {...linkify(handleClick, video.name)}>
      <div
        class="single-card-image-wide"
        style={{
          backgroundImage: `url(${video.thumbnailUrl})`,
          ...(!showVideoTitle && { borderBottom: 0 }),
        }}
      >
        {showVideoDate && (
          <>
            {isLive && video.eventDate && (
              <div class="single-video-image-badge event-date">{eventDate}</div>
            )}
            {!isLive && video.duration && (
              <div class="single-video-image-badge duration">{video.duration}</div>
            )}
          </>
        )}
      </div>
      {showVideoTitle && (
        <div class="single-video-info">
          <h5 class="single-video-title h5 single-h5">{video.name}</h5>
        </div>
      )}
    </div>
  );
};
